<div class="container">
    <img [src]="logoUrl" alt="logo" *ngIf="logoUrl" class="logo-corner"/>
    <app-spinner-square [online]="true" *ngIf="!logoUrl"></app-spinner-square>
    <app-round-progress-widget class="round-progress" [label]="label" [total]="playerCount" [value]="submissionCount"></app-round-progress-widget>
</div>
